import { GET_SECURITY_APPLICATION_DETAILS_ACTION_TYPE, INSERT_UPDATE_SECURITY_APPLICATION_ACTION_TYPE } from "../../../../../utils/constants";

const initialState = [];

function securityApplicationReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case GET_SECURITY_APPLICATION_DETAILS_ACTION_TYPE:
            return [...state, payload];
        case INSERT_UPDATE_SECURITY_APPLICATION_ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default securityApplicationReducer;